<div class="full-width fx-col-w-100 fx-gap-20 pr-25 pl-30">
  <div class="fx-row-w-100 fx-gap-15">
    <span class="subtitle-default">{{ pageLabel }}</span>

    <button class="button-action" mat-flat-button
            *ngIf="survey && equalsIgnoreCase(survey.status, SurveyStatus.DRAFT)"
            (click)="publishSurvey()"
            [disabled]="(loading$ | async) || appSurveyDetails.surveyForm.dirty || pendingChanges">
      <div class="button-text">Publish</div>
    </button>

    @switch (selectedTab) {
      @case ('details') {
        <button class="button-action-cancel" mat-flat-button
                *ngIf="pendingChanges"
                (click)="onCancelChanges()"
                [disabled]="(loading$ | async) || !appSurveyDetails.surveyForm.dirty">
          <div class="button-text">Cancel</div>
        </button>
        <button class="button-action" mat-flat-button
                *ngIf="pendingChanges"
                (click)="appSurveyDetails.onSubmit()"
                [disabled]="(loading$ | async) || !appSurveyDetails.surveyForm.dirty">
          <div class="button-text">{{ (loading$ | async) ? 'Working...' : 'Update' }}</div>
        </button>
      }
      @case ('questions') {
        <button class="button-action-cancel" mat-flat-button
                *ngIf="pendingChanges"
                (click)="onCancelChanges()"
                [disabled]="(loading$ | async)">
          <div class="button-text">Cancel</div>
        </button>
        <button class="button-action" mat-flat-button
                *ngIf="pendingChanges"
                (click)="onSaveQuestions()"
                [disabled]="(loading$ | async) || (!survey.allowMultiSubmission && !questionsComponent.hasEmailQuestion)">
          <div class="button-text">{{ (loading$ | async) ? 'Working...' : 'Update' }}</div>
        </button>
      }

      @case ('smart-form') {
        <button class="button-action-cancel" mat-flat-button
                *ngIf="pendingChanges"
                (click)="onCancelChanges()"
                [disabled]="(loading$ | async)">
          <div class="button-text">Cancel</div>
        </button>
        <button class="button-action" mat-flat-button
                *ngIf="pendingChanges"
                (click)="onSaveSmartConfig()"
                [disabled]="(loading$ | async)">
          <div class="button-text">{{ (loading$ | async) ? 'Working...' : 'Update' }}</div>
        </button>
      }
    }

    <button class="button-action" mat-flat-button
            *ngIf="survey"
            (click)="previewForm()"
            [disabled]="(loading$ | async)">
      <div class="button-text">Preview</div>
    </button>

    <div class="fx-spacer"></div>
    <button (click)="switchTabs('details')"
            [class.button-tab-active]="selectedTab == 'details'"
            [class.disabled-tab-button]="!canNavigate('details')"
            [disabled]="!canNavigate('details')"
            class="button-tab" mat-flat-button>
      <div class="button-text">Details</div>
    </button>

    <button (click)="switchTabs('questions')"
            [class.button-tab-active]="selectedTab == 'questions'"
            [class.disabled-tab-button]="!canNavigate('questions')"
            [disabled]="!canNavigate('questions')"
            class="button-tab" mat-flat-button>
      <div class="button-text">Questions</div>
    </button>

    <button (click)="switchTabs('smart-form')"
            [class.button-tab-active]="selectedTab == 'smart-form'"
            [class.disabled-tab-button]="!canNavigate('smart-form')"
            [disabled]="!canNavigate('smart-form')"
            class="button-tab" mat-flat-button>
      <div class="button-text">SMART Form</div>
    </button>
  </div>

  @switch (selectedTab) {
    @case ('details') {
      <mat-sidenav-container class="sidenav-container survey-details-sidenav-container body-1-regular-2">
        <!-- Right sidenav -->
        <mat-sidenav #rightSidenav
                     mode="side"
                     position="end"
                     class="sidenav-right"
                     [opened]="true"
                     [fixedInViewport]="false"
                     [fixedTopGap]="0"
                     [fixedBottomGap]="0">

          <div class="sidenav-right-content" fxLayout="column" fxFlex="220px">
            @if(offering && survey){
              <app-survey-qrcode-configuration
                [offering]="offering!"
                [surveyCode]="survey.code!"></app-survey-qrcode-configuration>
            }
            @else{
              <app-info-panel [message]="['Loading survey data...']"
                              [fullWidth]="true"
                              [type]="PanelType.INFO"
                              class="p-20">
              </app-info-panel>
            }

          </div>

        </mat-sidenav>

          <!-- Main content -->
          <mat-sidenav-content cdkScrollable class="sidenav-main-content pr-30" >
            <div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">

            </div>

            <app-survey-details #appSurveyDetails
                                [survey]="survey"
                                (updatedSurvey)="formTemplateChanges($event)"
                                [(pendingChanges)]="pendingChanges"></app-survey-details>
          </mat-sidenav-content>

      </mat-sidenav-container>



    }

    @case ('questions') {
      <app-survey-form-builder-questions #appSurveyFormBuilderQuestions
                                         [offering]="offering!"
                                         [formTemplate]="survey"
                                         [(pendingChanges)]="pendingChanges"
                                         (formChange)="formTemplateChanges($event)">
      </app-survey-form-builder-questions>
    }

    @case ('smart-form') {
      <app-survey-form-builder-configure-smart-form #appSurveyFormBuilderConfigureSmartForm
                                                    [offering]="offering!"
                                                    [formTemplate]="survey"
                                                    [(pendingChanges)]="pendingChanges"
                                                    (formChange)="formTemplateChanges($event)"
      >
      </app-survey-form-builder-configure-smart-form>
    }
  }
</div>
